import React from 'react'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import { getReportsSummary } from 'client/utils/api-routes-analytics'
import moment from 'moment'
import {
  DcBreadcrumbs,
  DcDateRangePicker,
  DcFlexBox,
  PixelDiv,
  PixelFactoryContext,
  PixelPageContainer,
  Section,
  SectionContent,
  colors,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs-compat'

import { IPixelFactory } from 'client/../decl'

import CardView from './components/CardView'

const breadcrumbs = [
  {
    name: 'Reports',
    active: false,
  },
  {
    name: 'Orders & Sales Summary',
    active: true,
  },
]

const Reports: React.FC = () => {
  const currentDate = new Date()
  const start_date = new Date(currentDate)
  start_date.setDate(currentDate.getDate() - 30)
  const end_date = new Date(currentDate)
  const { showLoader, hideLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const reportsRef = React.useRef<HTMLDivElement>(null)
  const [filters, setFilters] = React.useState({
    start_date: start_date,
    end_date: end_date,
    data_type: 'monthly',
  })
  const [data, setData] = React.useState<any[]>([])
  const getReportSummary = (filter) => {
    showLoader(reportsRef)
    getReportsSummary(filter).subscribe((res: AjaxResponse<any>) => {
      hideLoader(reportsRef)
      setData(res.response?.data)
    })
  }
  React.useEffect(() => {
    getReportSummary(formateDate(filters))
  }, [])
  const formateDate = (filters) => {
    return {
      start_date: moment(filters.start_date).format('YYYY-MM-DD'),
      end_date: moment(filters.end_date).format('YYYY-MM-DD'),
      data_type: filters.data_type,
    }
  }
  return (
    <>
      <DcFlexBox
        height="60px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: `1px solid ${colors.grayBorderLight}`,
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs data={breadcrumbs} />
          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer padding="0px">
        <Section style={{ padding: '0px' }}>
          <SectionContent
            style={{ padding: '5px 20px 5px 20px', borderRadius: '0px' }}
          >
            <DcDateRangePicker
              size="sm"
              month={2}
              ranges={filters}
              onApply={() => {
                getReportSummary(formateDate(filters))
              }}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  start_date: new Date(e.range1.startDate),
                  end_date: new Date(e.range1.endDate),
                })
              }}
            />
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }}>
          <SectionContent className="reports" ref={reportsRef}>
            <PixelDiv
              style={{ height: 'calc(100vh - 160px)', overflow: 'auto' }}
            >
              <CardView data={data} />
            </PixelDiv>
          </SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}

export default Reports
